<template>
    <v-flex xl12>
        <v-card flat>
            <v-card-text>
                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>
                <h3>Editar banner</h3>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-container fluid grid-list-lg>
                        <v-layout row wrap>

                            <v-flex xl4 lg4 md4 sm12 xs12>
                                <v-text-field
                                        v-model="register.title"
                                        :rules="nameRules"
                                        label="Nome do banner"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl4 lg4 md4 sm12 xs12>
                                <v-text-field
                                        v-model="register.link"
                                        label="Link do banner (Opcional)"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xl4 lg4 md4 sm12 xs12>
                                <v-select
                                        required
                                        v-model="register.target"
                                        :items="[
                                           {target:'_self', text:'Na mesma página'},
                                           {target:'_blank', text:'Nova página'}
                                        ]"
                                        item-value="target"
                                        item-text="text"
                                        label="Comportamento"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-flex xl12 lg12 md12 sm12 xs12 class="right">
                        <v-btn flat class="primary" @click="submit">Salvar</v-btn>
                        <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                    </v-flex>
                </v-form>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    export default {
        name: 'bannes-edit',
        data: () => ({
            register: JSON.parse(localStorage.getItem('register')),
            valid: true,
            select: false,
            error: false,
            success: false,
            loading: false,
            preview: '',
            banner: {},
            messages: '',
            banner_default: '',
            categories: [],
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ]
        }),
        methods: {
            deleteBanner: function () {
                this.banner = ''
                this.preview = ''
                this.select = false
            },
            onUpload() {
                if (!this.disabled) {
                    this.$refs.fileInput.click()
                }
            },
            onFileChange(e) {
                var self = this
                var files = e.target.files
                var ext = files[0].name.substring(files[0].name.lastIndexOf('.') + 1)
                if ((ext === 'jpeg') || (ext === 'jpg') || (ext === 'png')) {
                    self.banner = files[0]
                    this.createImage(self.banner)
                } else {
                    self.error = true
                    self.messages = 'Arquivo não suportado'
                }
            },
            createImage(file) {
                var self = this
                var reader = new FileReader()
                var vm = this
                reader.onload = (e) => {
                    vm.result = e.target.result
                    self.preview = vm.result
                    self.select = true
                }
                reader.readAsDataURL(file)
            },
            submit () {
                var self = this
                self.messages = ''
                if (this.$refs.form.validate()) {
                    this.loading = true
                    this.axios.post('/edit-banners.json', self.register, {
                        headers: {
                            'Authorization': self.$store.state.token
                        }
                    }).then(function (response) {
                        self.loading = false
                        if (response.data.success === true) {
                            self.messages = response.data.messages
                            self.success = true
                            setTimeout(function () {
                                self.$router.push('/banners')
                            }, 2000)
                        } else {
                            self.error = true
                            self.messages = response.data.messages
                        }
                    })
                }
            },
            clear() {
                this.$router.push('/banners')
            }
        }
    }
</script>
